export default "__VITE_ASSET__d5ef64bc__"